import RougeExclusiveBadge from 'components/Badges/RougeExclusiveBadge/RougeExclusiveBadge';

export default RougeExclusiveBadge;
